





































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Aisle from "../../../store/entities/aisle";
import AppConsts from "../../../lib/appconst";
import util from "../../../lib/util";
@Component
export default class UpdateAisle extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  aisle: Aisle = new Aisle();
  spinShow = false;
  id: string ='';
  roomCode :string ='';
  save() {
    (this.$refs.aisleForm as any).validate(async (valid: boolean) => {
          if (valid) {
              this.$Modal.confirm({
                title:this.L('Tips'),
                content:this.L('Confirm.UpdateAisle'),
                okText:this.L('Yes'),
                cancelText:this.L('No'),
                onOk:async()=>{
                    this.spinShow=true;
                    try {
                          await this.$store.dispatch({
                                type: "aisle/update",
                                data: this.aisle
                              });
                        Util.showSuccessMsg(this,'Success.UpdateAisle');
                        this.$emit("save-success");
                        this.onGoBack();
                        this.spinShow=false;
                    } catch (error) {
                       this.spinShow=false; 
                    }
                }
        });
      }
    });
    
  }
   onGoBack(){
      (this.$refs.aisleForm as any).resetFields();
      this.$emit("input", false);
      this.$root.$router.push({name: 'aisle'});
  }
   async getAisleInfo()
  {
       this.id =  this.$root.$router.currentRoute.params.id;
       this.roomCode =  this.$root.$router.currentRoute.params.roomCode;
      if(Util.isNull(this.id) || Util.isEmpty(this.id) || Util.isNull(this.roomCode) || Util.isEmpty(this.roomCode) )
        return;
      await this.$store.dispatch({
          type:'aisle/get',
          data: { id : this.id, roomCode: this.roomCode}
      }).then((result) => {
          this.aisle = result;
      });
  }
  convertValueLessThanZero(value)
  {
      if(Util.isEmpty(value.toString()))
        return value;
      var decimalValue = parseFloat(value);
      if( Util.isNull(decimalValue))
      {
          return 0;
      }
      decimalValue = decimalValue<0? 0: decimalValue;
      return decimalValue;
  }
  aisleRule = {
     height: [
      {
        required: true,
         type:'number',
        message: this.L("Error.RequiredField", undefined, this.L("Height")),
        trigger: "blur"
      }
    ], length: [
      {
        required: true,
        type:'number',
        message: this.L("Error.RequiredField", undefined, this.L("Length")),
        trigger: "blur"
      }
    ], width: [
      { 
        required: true,
         type:'number',
        message: this.L("Error.RequiredField", undefined, this.L("Width")),
        trigger: "blur"
      }
    ]
  };
 
  async created(){
     await this.getAisleInfo();
  }
}
